import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["tv", "television", "Radio"],
  iconColor: "#F05F33", // mars
  getIcon(options) {
    return createIcon(
      `
      <path
        d="M9.9375 5.66406L10.3359 6.0625L12 7.72656L13.6641 6.0625L14.0625 5.66406L14.8359 6.4375L14.4609 6.83594L13.5469 7.75H16.875H18V8.875V16.375V17.5H16.875H7.125H6V16.375V8.875V7.75H7.125H10.4531L9.53906 6.83594L9.14062 6.4375L9.9375 5.66406ZM7.125 8.875V16.375H16.875V8.875H7.125ZM15.75 10.1875C16.0547 10.1875 16.3125 10.4453 16.3125 10.75C16.3125 11.0781 16.0547 11.3125 15.75 11.3125C15.4219 11.3125 15.1875 11.0781 15.1875 10.75C15.1875 10.4453 15.4219 10.1875 15.75 10.1875ZM15.1875 12.625C15.1875 12.3203 15.4219 12.0625 15.75 12.0625C16.0547 12.0625 16.3125 12.3203 16.3125 12.625C16.3125 12.9531 16.0547 13.1875 15.75 13.1875C15.4219 13.1875 15.1875 12.9531 15.1875 12.625ZM14.25 10V15.25H8.25V10H14.25Z"
        fill="#F05F33" />
      `,
      "#FDEFEB", // mars-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
